// extracted by mini-css-extract-plugin
export default {"errorWrapper":"ComponentErrorBoundary_errorWrapper__V7bnl","errorItem":"ComponentErrorBoundary_errorItem__lV3C7"};